module.exports = __webpack_public_path__ + "static/media/img_for_test.56a6a619.svg";